import React from 'react';
import { Cpu, Cloud, Radio, BarChart3, Smartphone, LayoutDashboard } from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { platformArchitecture } from '../data/overview';

const iconMap = {
  firmware: Cpu,
  cloud: Cloud,
  realtime: Radio,
  analytics: BarChart3,
  apps: Smartphone,
  dashboard: LayoutDashboard,
} as const;

export const PlatformArchitecture: React.FC = () => (
  <SiteSection id="platform-architecture" className="platform-architecture-section">
    <SiteSectionHeader
      title={platformArchitecture.title}
      subtitle={platformArchitecture.subtitle}
      align="center"
    />
    <div className="platform-arch">
      <div className="platform-arch__track" aria-hidden>
        <span className="platform-arch__line" />
      </div>
      <div className="platform-arch__strip">
        {platformArchitecture.blocks.map((block, index) => {
          const Icon = iconMap[block.id as keyof typeof iconMap];
          const step = String(index + 1).padStart(2, '0');
          return (
            <React.Fragment key={block.id}>
              {index > 0 ? <span className="platform-arch__connector" aria-hidden /> : null}
              <article className="platform-arch__card">
                <span className="platform-arch__step">{step}</span>
                <div className="platform-arch__icon">
                  <Icon className="platform-arch__icon-svg" strokeWidth={1.75} aria-hidden />
                </div>
                <div className="platform-arch__body">
                  <h3 className="platform-arch__title">{block.title}</h3>
                  <p className="platform-arch__desc">{block.description}</p>
                </div>
              </article>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  </SiteSection>
);
